import getters from "./getters";
import mutations from "./mutations";
import actions from "./actions";

export default {
  namespaced: true,
  state: { flexiFund: null, textPay: null, quickSwap: null, shareGain: null },
  getters,
  mutations,
  actions,
};
